// Categorized interests for user profiles
export const INTEREST_CATEGORIES = {
  "Business & Beyond": [
    "Coaching & Development",
    "Professional Networking",
    "Business & Law",
    "Marketing & Sales",
    "Entrepreneurship & Start Ups",
    "Engineering & Technology",
    "NGOs & International Development",
    "International Relations & Development"
  ],
  "Fit & Fun": [
    "Adventure Sports",
    "Badminton & Squash",
    "Basketball",
    "Volleyball",
    "Bowling",
    "Cycling",
    "Dancing",
    "Diving",
    "Golf",
    "Hiking",
    "Rock Climbing & Bouldering",
    "Rugby & American Football",
    "Running & Walking",
    "Sailing & Boating",
    "Winter Sports",
    "Soccer",
    "Surfing",
    "Swimming",
    "Tennis",
    "Health & Wellness",
    "Billiards & Darts",
    "Ping Pong & Table Tennis",
    "Fitness",
    "Frisbee",
    "Fencing",
    "Skating",
    "Horse Riding"
  ],
  "Bites & Bright Lights": [
    "Whiskey & Spirits",
    "Wine",
    "Alcohol Free",
    "Clubbing",
    "Cocktails & Longdrinks",
    "Dining Out",
    "Lunch & Brunch",
    "Pubs",
    "Bars & Lounges",
    "Coffee & Tea",
    "Shisha & Fine Tobacco",
    "Beer"
  ],
  "More to Explore": [
    "Cooking",
    "Handcrafting",
    "Photography",
    "Traveling",
    "Nature",
    "Sightseeing",
    "Languages & Cultures",
    "Local Culture"
  ],
  "Arts & Culture": [
    "Games",
    "Classical Music",
    "Arts",
    "Jazz Music",
    "Literature & Creative Writing",
    "Live Music & Concerts",
    "Making Music",
    "Movies",
    "Ballet & Opera",
    "Painting & Drawing",
    "Philosophy & Politics",
    "Science",
    "Spirituality & Religion",
    "Comedy",
    "Theater",
    "Museums & Exhibitions",
    "Karaoke"
  ]
};

// Category icons and colors for visual distinction
export const CATEGORY_STYLES = {
  "Business & Beyond": {
    icon: "Briefcase",
    bgColor: "from-emerald-600 to-teal-700",
    tagColor: "bg-emerald-100 text-emerald-800 border-emerald-200",
    selectedColor: "bg-emerald-500 text-white border-emerald-600"
  },
  "Fit & Fun": {
    icon: "Dumbbell",
    bgColor: "from-blue-500 to-cyan-600",
    tagColor: "bg-blue-100 text-blue-800 border-blue-200",
    selectedColor: "bg-blue-500 text-white border-blue-600"
  },
  "Bites & Bright Lights": {
    icon: "UtensilsCrossed",
    bgColor: "from-amber-500 to-orange-600",
    tagColor: "bg-amber-100 text-amber-800 border-amber-200",
    selectedColor: "bg-amber-500 text-white border-amber-600"
  },
  "More to Explore": {
    icon: "Compass",
    bgColor: "from-violet-500 to-purple-600",
    tagColor: "bg-violet-100 text-violet-800 border-violet-200",
    selectedColor: "bg-violet-500 text-white border-violet-600"
  },
  "Arts & Culture": {
    icon: "Palette",
    bgColor: "from-rose-500 to-pink-600",
    tagColor: "bg-rose-100 text-rose-800 border-rose-200",
    selectedColor: "bg-rose-500 text-white border-rose-600"
  }
};

// Helper to get all interests as a flat array
export const getAllInterests = () => {
  return Object.values(INTEREST_CATEGORIES).flat();
};

// Helper to find which category an interest belongs to
export const getCategoryForInterest = (interest) => {
  for (const [category, interests] of Object.entries(INTEREST_CATEGORIES)) {
    if (interests.includes(interest)) {
      return category;
    }
  }
  return null;
};

// Helper to group user interests by category
export const groupInterestsByCategory = (userInterests = []) => {
  const grouped = {};
  for (const [category, interests] of Object.entries(INTEREST_CATEGORIES)) {
    const matching = userInterests.filter(i => interests.includes(i));
    if (matching.length > 0) {
      grouped[category] = matching;
    }
  }
  return grouped;
};
